import { motion } from 'framer-motion';

export default function CircuitLines() {
  // Create 8 evenly spaced lines (every 45 degrees)
  const lines = Array.from({ length: 8 }, (_, i) => i * 45);
  
  return (
    <svg className="absolute inset-0 w-full h-full" viewBox="0 0 200 200">
      <defs>
        <filter id="circuit-glow">
          <feGaussianBlur stdDeviation="1.5" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>

      <g transform="translate(100 100)">
        {lines.map((angle, i) => {
          const radians = (angle * Math.PI) / 180;
          const innerRadius = 12; // Start from inner gear circle
          const outerRadius = 70; // Distance to outer dots
          
          const x1 = Math.cos(radians) * innerRadius;
          const y1 = Math.sin(radians) * innerRadius;
          const x2 = Math.cos(radians) * outerRadius;
          const y2 = Math.sin(radians) * outerRadius;
          
          return (
            <g key={`circuit-${i}`}>
              <motion.line
                x1={x1}
                y1={y1}
                x2={x2}
                y2={y2}
                stroke="#60A5FA"
                strokeWidth="2"
                filter="url(#circuit-glow)"
                animate={{
                  opacity: [0.4, 1, 0.4],
                  strokeWidth: ["2", "3", "2"],
                }}
                transition={{
                  duration: 2,
                  repeat: Infinity,
                  delay: i * 0.25, // Synchronized delays
                }}
              />
              <motion.circle
                cx={x2}
                cy={y2}
                r="4"
                fill="#60A5FA"
                filter="url(#circuit-glow)"
                animate={{
                  r: [4, 5, 4],
                  opacity: [0.4, 1, 0.4],
                }}
                transition={{
                  duration: 2,
                  repeat: Infinity,
                  delay: i * 0.25, // Synchronized delays
                }}
              />
            </g>
          );
        })}
      </g>
    </svg>
  );
}